export const visit = (vm, at) => {
at({ "cs": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} z {{totalBytes}}" }, "fileSizeLimit": "Velikost souboru nesm\xED p\u0159es\xE1hnout {{size}}." } } });
};